import React from "react";

import { Draggable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import classnames from "classnames/dedupe";
import Select from "react-select";

import { customStyles } from "components/custom-modal-elements/custom-modal-select";
import { FilterInput } from "./filter-input";
import Icon from "components/icon";

import styles from "./AdvancedFilters.module.scss";

const operatorMap = {
    AND: "OR",
    OR: "AND",
};

export const FilterBlock = (props) => {
    const { index, filter, setFilters, onChange, onDelete, advancedFiltersOptions, filterTypeOptions, filterValueOptions } = props;

    const advancedFilter = advancedFiltersOptions.find((f) => f.filterField === filter.filterField);

    const handleChangeOperator = (index) => {
        setFilters((prev) =>
            prev.map((filter, filterIndex) => (filterIndex === index ? { ...filter, operator: operatorMap[filter.operator] } : filter))
        );
    };

    const { t } = useTranslation();

    const getFilterType = () => {
        if (!advancedFilter) return null;

        const filterType = filterTypeOptions[advancedFilter.type].find((o) => o.value === filter.filterType);
        if (filterType) return filterType;

        return null;
    };

    return (
        <>
            <Draggable draggableId={`filter-${index}`} index={index}>
                {(provided, snapshot) => (
                    <div className={styles.filtersBlock} {...provided.draggableProps} ref={provided.innerRef}>
                        <div className={styles.filtersDragPin} {...provided.dragHandleProps}>
                            <Icon name={["fas", "bars"]}></Icon>
                        </div>
                        <div className={styles.filtersContent}>
                            <div
                                className={styles.operator}
                                onClick={() => handleChangeOperator(index)}
                                style={index === 0 ? { cursor: "default" } : undefined}
                            >
                                {t(index === 0 ? "WHERE" : filter.operator)}
                            </div>
                            {/* Filter field */}
                            <Select
                                className="custom-gt-select"
                                styles={customStyles}
                                options={advancedFiltersOptions}
                                onChange={(e) => onChange(e.filterField, index, "column")}
                                placeholder={`${t("Field")}...`}
                                value={advancedFilter || null}
                                getOptionLabel={(o) => o.filterLabel}
                                getOptionValue={(o) => o.filterField}
                                noOptionsMessage={() => t("No options")}
                            />
                            {/* Filter type */}
                            <Select
                                className="custom-gt-select"
                                styles={customStyles}
                                options={advancedFilter ? filterTypeOptions[advancedFilter.type] : []}
                                onChange={(o) => onChange(o.value, index, "condition")}
                                placeholder={`${t("Filter type")}...`}
                                value={getFilterType()}
                                isDisabled={advancedFilter?.filterOptionConfig || advancedFilter?.type === "checkbox"}
                                noOptionsMessage={() => t("No options")}
                            />
                            <FilterInput
                                advancedFilter={advancedFilter}
                                filter={filter}
                                onChange={onChange}
                                filterValueOptions={filterValueOptions}
                                index={index}
                                placeholder={`${t("Value")}...`}
                            />
                            <div
                                className={classnames(styles.deleteButton, "btn btn-custom-round align-items-center")}
                                onClick={() => onDelete(index)}
                                title={t("Remove filter")}
                            >
                                <Icon name="trash" color="#ef5164ee" />
                            </div>
                        </div>
                    </div>
                )}
            </Draggable>
        </>
    );
};
